import Request from './../request';
import { IRoleResourceShort } from '../../props/roles';

// import interfaces

const RoleServices = {
  retrieve: async (): Promise<IRoleResourceShort[]> => {
    try {
      const results = await Request.get(`/api/roles`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  create: async (data: FormData): Promise<IRoleResourceShort[]> => {
    try {
      const results = await Request.post(`/api/roles`, data, 'multipart/form-data');
      return results;
    } catch (e) {
      throw e;
    }
  },
  update: async (data: FormData, id: string): Promise<IRoleResourceShort[]> => {
    try {
      const results = await Request.post(`/api/roles/${id}?_method=PUT`, data, 'multipart/form-data');
      return results;
    } catch (e) {
      throw e;
    }
  },
  delete: async (id: string): Promise<IRoleResourceShort[]> => {
    try {
      const results = await Request.delete(`/api/roles/${id}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
};

export default RoleServices;
